// import external dependencies
import 'jquery';
import '@fancyapps/fancybox';
// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import pdf from './modules/pdf';
import menu from './modules/menu';
import hovers from './modules/hovers';
import tabs from './modules/tabs';
import slider from './modules/slider';
import loadPages from './modules/loadPages';
import map from './modules/map';
import accordion from './modules/accordion';
import banners from './modules/banners';
import news from './modules/news';
import search from './modules/search';
// import align_images from './modules/content-images-alignment';  // useless solution

import calendar from './modules/calendar';
import player from './modules/player';
import parallax from './modules/parallax';



/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

pdf();
// align_images();
menu();
hovers();
tabs();
slider();
loadPages();
map();
accordion();
banners();
parallax();
news();
calendar();
player();
search();

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js